import React, { Component } from "react";
import {  Menu, MenuItem, Paper, withStyles } from "@material-ui/core";
import Input from "../../../../components/InputBox/Input";

import {
  userSession
} from "../../../../services/chartDetailsApi";

import moment from "moment";
import Snackbar from "../../../../components/snackbar/snackbar";
import BarGraph from "./graph/barGraph";
import ReactToPrint from "react-to-print";
import Modal from "../../../../components/modal/modal";
import Pbutton from "../../../../components/button/Button";
import { withRouter } from "react-router-dom";
import { CSVLink } from "react-csv";
import ReactSelect from "../../../../components/reactSelect/reactSelect";
import TableComponent from "./table/index";

// CSS file
import '../../Common.scss'
import "../index.css";
import "../../../../static/scss/globalComponent.scss";

import { countries } from "../../../../fixtures/dummyApi/countries";
import _ from "lodash";
import Filters from "../../../../components/filter/location/filter";
import { dateTimeFormatForGraph, getCurrencySymbol, groupFormat, setInLocalStorage, tooltipFormatter } from "../../../../lib/helper";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  dataHeader: {
    width: "150px",
    fontSize: "10px",
    fontFamily: "Poppins",
    maxWidth: "170px",
    minWidth: "150px",
    textAlign: "center",
    fontWeight: 600,
    color: "#484848",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  data: {
    width: "150px",
    fontSize: "10px",
    fontFamily: "Poppins",
    maxWidth: "170px",
    minWidth: "150px",
    textAlign: "center",
  },
  menuItem: {
    width: "300px",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  selectCountryButton: {
    background: "#FFF",
    border: "1px solid #bbb",
    borderRadius: "4px",
    padding: "7px 12px",
    marginLeft: "10px",
  },
});

class UserSession extends Component {
  myRef = React.createRef();
  state = {
    snackBarMessage: "",
    showSnackbar: false,
    isExport: false,
    vehicle_type_id: 0,
    isMoreThanThousand: false,
    noDataText: "Loading Data ...",


    loader: true, //loader state
    noData: false,
    dataLoaded: false,
  
    // currency state
    currencyData: localStorage.getItem("currency")
    ? JSON.parse(localStorage.getItem("currency"))
    : "INR",

  /**
   * @DescriptionDocer uncomment below state and comment above all state realted to currency 
   */
  // currencyData: window._env_.CURRENCY,
  // previousCurrencyData: window._env_.CURRENCY,    

    // start and end date
    date: {
      startDate:
        localStorage.getItem("startDate") != null
          ? localStorage.getItem("startDate")
          : moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      endDate:
        localStorage.getItem("endDate") != null
          ? localStorage.getItem("endDate")
          : moment().format("YYYY-MM-DD HH:mm:ss"),
    },

    // set group by value and list
    selected: localStorage.getItem("selectedGroupBy")
      ? JSON.parse(localStorage.getItem("selectedGroupBy"))
      : { value: 0, label: "Hour" },
    selectData: [{ value: 0, label: "Hour" }],

    exportData:[],
    logsData: [], //table data
    columns: [], //table columns

    dataCount:0,
    skip: 0, //starting point
    limit: 10, //ending point
    page: 1, //pagination page
    dataToShow: 10, //50 or 100 data to show
    showTable: false,


    sortingType : "ASC",
    filterColumnName: ""

  };

  /**
   * @Author Jai
   * @Date 15 July, 2021
   * @Description Created a Total Earning Chart and added a DateRange, GroupBy, Currency and Source filter
   */

  componentDidMount() {
    this.intermediate();
  }

  // this function call whenever there is a update in the whole component
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.date.startDate       !== prevState.date.startDate||
      this.state.date.endDate         !==  prevState.date.endDate ||

      this.state.filterColumnName     !== prevState.filterColumnName ||
      this.state.sortingType          !== prevState.sortingType ||

      this.state.page                 !== prevState.page ||
      this.state.dataToShow           !== prevState.dataToShow ||      

      this.state.selected.value       !== prevState.selected.value
    ) {
      this.setState({
        loader:true,
        noDataText: "Loading Data ...",
      });
      this.intermediate();
    }
  }

  intermediate = () => {
    this.getData(
      this.state.date.startDate,
      this.state.date.endDate,
      parseInt(this.state.selected.value),
      this.state.filterColumnName,
      this.state.sortingType,
      this.state.skip,
      this.state.limit
    );
  };

  getData = (
    start_timestamp,
    end_timestamp,
    groupBy,
    columnName,
    sortType,
    skip,
    limit
  ) => {
    userSession(
      moment(start_timestamp).unix(),
      moment(end_timestamp).unix(),
      groupBy || 0,
      columnName,
      sortType,
      skip,
      limit
    )
      .then((response) => {
        let xCategories = dateTimeFormatForGraph(
          this.state.selected.label || "Hour",
          response.data.graph.xaxis.categories
        );

        //graph configuration
        let graphData = {
          series: response.data.graph.series,
          options: {
            title: {
              text: "",
              align: "left",
              style: { fontSize: "18px", fontWeight: 500 },
            },
            dataLabels: { enabled: false },
            chart: {
              height: 350,
              type: 'bar'
            },
            xaxis: {
              type: "category",
              categories: xCategories,
              title: {
                text: response.data.graph.xaxis.title,
                style: {
                  fontSize: "11px",
                  fontWeight: 700,
                  paddingRight: "20px",
                },
              },
              tickPlacement: "on",
              tooltip: {
                enabled: false,
              },
            },

            grid :{
              padding:{
                left :40,

              }
            },

            legend: {
              position: "top",
              // showForSingleSeries: true,
            },
            yaxis: {
              title:{
                text:response.data.graph.yaxis.title
              },
              opposite: false,
              labels: {
                offsetX: 15,
                show: true,
                style: { fontSize: "11px" },
                formatter: (val, index) => {
                  return tooltipFormatter(val, this.state.currencyData, false);
                },
              },
            },
            tooltip: {
              enabled: true,
              followCursor: true,
              y: {
                formatter: (val, series) => {
                  return tooltipFormatter(val, this.state.currencyData, false);
                },

                title: {
                  formatter: (seriesName) => seriesName,
                },
              },
            },
          },
        };

        // table data
        let columns = Object.keys(response.data.table[0]); // column name from api
        columns[0] = this.state.selected.label;
        let cold = columns.map((item, index) => {
          // modified column name according to table structure
          return {
            Header: item[0].toUpperCase() + item.slice(1),
            accessor: (data) => {
              if (
                item.toLowerCase().includes("date") &&
                this.state.selected.value < 1
              )
                return moment(Object.values(data)[index]).format(
                  "DD-MMMM-YYYY LT"
                );
              else {
                let type = typeof Object.values(data)[index];
                if (type === "number")
                  return (
                    Object.values(data)[index] &&
                    Object.values(data)[index].toFixed(2)
                  );
                else return Object.values(data)[index];
              }
            },
            id: item,
            show: true,
            width: 150,
          };
        });

        let exportData = response.data.table.map((data=>{
          let tempData = {...data}
          tempData[this.state.selected.label === "Hour Of Day" ? "Hour of day" 
          : this.state.selected.label] = this.state.selected.value === 7 ? tempData["Day of week"] : moment(tempData[this.state.selected.label === "Hour Of Day" ? "Hour of day" : this.state.selected.label]).format(groupFormat[this.state.selected.label])
          return tempData
        }))

        this.setState({
          showTable: true,
          logsData :response.data.table, // table data
          columns : cold, // table column name
          loader:false,
          dataCount: response.data.count,
          dataLoaded: true,
          graphData, // chart data
          exportData,
          noDataText: "",
        });
      })
      .catch((error) => {
        if (!this.state.date.startDate) {
          this.setState({
            showSnackbar: true,
            snackBarMessage: "Please select a date range",
          });
        } else {
          let message =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
              ? error.response.data.message
              : "Data Not Found For the Given Date Range!";
          this.setState({
            dataLoaded: false,
            showTable: false,
            loader: false,
            showSnackbar: true,
            snackBarMessage: message,
            noDataText: "No data for the selected date range",
          });
        }
        setTimeout(() => {
          this.setState({
            showSnackbar: false,
          });
        }, 1000);
        console.log("Api error", error);
      });
  };
  // ========= End of getData function ============ //


  columnFilter = (header) => {
    let type =  this.state.sortingType === "DESC" ? "ASC" : "DESC"
    this.setState({
          sortingType : type,
          filterColumnName : header
    })
  }

  // Date manipulating
  handleDateRange = (startDate, endDate, groupBy, selectedGroupBy) => {
    this.setState(
      {
        date: {
          startDate: startDate,
          endDate: endDate,
        },
        selectData: groupBy,
        selected: selectedGroupBy,
        loader: true,
      }
    );
  };

  //  groupBy manipulating
  selectHandler = (option) => {
    this.setState({ selected: option, loader: true });
  };

  returnDataWithTwoDecsOrInteger = (n, index) => {
    let tableIndex = [0,1,2]
    if (Number(n) === n && n % 1 === 0) {
      return tableIndex.includes(index) ? tooltipFormatter(n, this.state.currencyData, false) : n;
    } else if (Number(n) === n && n % 1 !== 0) {
      return tableIndex.includes(index) ? tooltipFormatter(parseFloat(n.toFixed(2)), this.state.currencyData, false) : parseFloat(n.toFixed(2));
    } else if (String(n)) {
      return n;
    }

  };

  // change pagination page  respectively set SKIP and LIMIT
  changeActivePage = (page) => {
    let state = { ...this.state };

    state.skip = page * state.dataToShow - state.dataToShow;
    state.limit = state.dataToShow;

    state.page = page;
    state.loader = true;
    this.setState(state)
  }

  //set data to show and respectively set SKIP and LIMIT  
  dataToShowHandler = (newVal) => {
    let stateCopy = { ...this.state };

    stateCopy.page = 1;
    stateCopy.skip = 0
    stateCopy.limit = stateCopy.page * newVal;
    stateCopy.dataToShow = newVal;
    stateCopy.loader = true;
    this.setState(stateCopy)
  }


  tableDateRender = (date) => {
    let format = {
      Hour: "ll H:00",
      Day: "ll",
      Week: "ll",
      "Hour Of Day": "HH:00",
      'Day Of Week': "ddd",
      Year: "ll",
      Month: "MMM YY",

    };

    if (this.state.selected.value === 7 &&  date['Day of week']){
        return date['Day of week'];
    }
    else if (this.state.selected.value === 6 &&  date['Hour of day']){
      return moment(date['Hour of day']).format(format['Hour Of Day']);
    }
    else if (Object.keys(format).includes(this.state.selected.label)) {
      return moment(date[this.state.selected.label]).format(format[this.state.selected.label]);
    } else {
      return date[this.state.selected.label];
    }
  };  

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className="containerDiv" ref={this.myRef}>
          <div className="">
            <div
              className="hoverPathClass globalFontSize"
              onClick={() =>
                this.props.history.push("analytics-overview")
              }
            >
              <i className="fas fa-angle-left mr-2"></i>Reports
            </div>
            <div className="title">User Session</div>
            <div className="d-flex text-grey mt-2" style={{ marginBottom: "" }}>
              <div className="mr-3 db_ptr changeCurssor">
                <ReactToPrint
                  trigger={() => (
                    <span>
                      <i className="fas fa-print mr-1"></i>Print
                    </span>
                  )}
                  content={() => this.myRef.current}
                />
              </div>
              <div
                className="mr-3 db_ptr changeCurssor"
                onClick={() =>
                  this.setState({ isExport: !this.state.isExport })
                }
              >
                <i className="fas fa-download mr-1"></i>Export
              </div>
            </div>
            <div
              className="moreThanThousand"
              style={{ display: this.state.isMoreThanThousand ? "" : "none" }}
            >
              <div className="iconDiv">
                <span className="iconSpan"></span>
              </div>
              <div className="bannerContent">
                This report shows up to 1,000 results. To see all results, you
                can
              </div>
            </div>
            <div className="d-flex align-items-center mt-2">
              <Filters
                // showCountry={false}
                handleDateChange={this.handleDateRange}
                groupByselectData={this.state.selectData}
                groupByselectHandler={this.selectHandler}
                groupByselected={this.state.selected}
              ></Filters>
            </div>
          </div>
          <div
            className="activeBarGraph d-flex align-items-center justify-content-center"
            style={{ marginTop: "20px" }}
          >
            {this.state.loader ? (
              <h4 style={{ color: "grey" }}>Loading data...</h4>
            ) : this.state.dataLoaded ? (
              <div
                style={{
                  height: "100%",
                  width: "100%",
                }}
              >
                <BarGraph config={this.state.graphData} />
              </div>
            ) : (
              <h4 style={{ color: "grey" }}>No data for selected date range</h4>
            )}
          </div>

          <div
            className="d-flex  justify-content-center"
            style={{
              marginTop: "50px",
            }}
          >
            {this.state.loader ? (
            <div className="no-data-loader">
              <h4 style={{ color: "grey" }}>Loading data...</h4>
            </div>
            ) : this.state.dataLoaded ? (
              <TableComponent 
                loader={this.state.loader}
                currency= {this.state.currencyData}
                showTable={this.state.showTable}
                columns={this.state.columns}
                logsData={this.state.logsData}

                dateRender={(data) => this.tableDateRender(data)}
                returnDataWithTwoDecsOrInteger={(data, index) =>
                  this.returnDataWithTwoDecsOrInteger(data, index)
                }
                page={this.state.page}
                dataCount={this.state.dataCount}
                dataToShow={this.state.dataToShow}
                changeActivePage={this.changeActivePage}
                dataToShowHandler={this.dataToShowHandler}

                sortType = {this.columnFilter}
                filterColumnName = {this.state.filterColumnName}

              />
            ) : (
            <div className="no-data-loader">
              <h4 style={{ color: "grey" }}>No data for selected date range</h4>
            </div>
            )}
          </div>

          {/* Export Modal will only open when user click on export button then only this modal will to ask for export and cancel */}
          <Modal
            isOpen={this.state.isExport}
            toggle={() => this.setState({ isExport: !this.state.isExport })}
            width={"35%"}
          >
            <div className="col-12 px-0">
              <div className="py-3 reportModal-header pl-3 border-bottom">
                Export your Table Data
              </div>
              <div className="py-3 reportModal-subText pl-3 border-bottom">
                Table will be exported as a CSV (comma separated values).
              </div>
              <div className="py-3 col-12">
                <div className="d-flex justify-content-end">
                  <Pbutton
                    onClick={() =>
                      this.setState({ isExport: !this.state.isExport })
                    }
                    className="reportModal-cancelBtn"
                  >
                    Cancel
                  </Pbutton>
                  <CSVLink
                    onClick={() =>
                      this.setState({ isExport: !this.state.isExport })
                    }
                    data={this.state.exportData}
                    filename={"user-session.csv"}
                    className="reportModal-exportBtn"
                    target="_blank"
                  >
                    Export
                  </CSVLink>
                </div>
              </div>
            </div>
          </Modal>
          <Snackbar
            open={this.state.showSnackbar}
            message={this.state.snackBarMessage}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(UserSession));
